import { ComponentPropsWithoutRef } from 'react';

interface LogoIconProps extends ComponentPropsWithoutRef<'svg'> {
  circleGradientId?: string;
}

export const LogoIcon = ({
  circleGradientId = 'paint0_linear_1799_8480',
  ...props
}: LogoIconProps) => {
  return (
    <svg {...props} viewBox="0 0 40 41" fill="none">
      <path
        d="M20 .5C8.974.5 0 9.475 0 20.5c0 11.024 8.974 20 20 20s20-8.975 20-20c0-11.026-8.973-20-20-20Zm0 33.077c-7.2 0-13.055-5.866-13.055-13.077S12.801 7.423 20 7.423 33.055 13.289 33.055 20.5c0 7.21-5.856 13.077-13.055 13.077Z"
        fill={`url(#${circleGradientId})`}
      />
      <path
        d="M19.987 29.5c5.044-.023 9.01-4.044 9.013-8.96 0-4.95-4.05-9.04-8.955-9.04-4.978 0-9.019 3.995-9.045 8.893a9.06 9.06 0 0 0 2.603 6.438 8.973 8.973 0 0 0 2.926 1.977 8.939 8.939 0 0 0 3.458.692Zm-3.664-12.605c1.054-1.07 2.351-1.583 3.864-1.495.556.034 1.203.227 1.554.47l-6.257 6.19c-.282-.306-.448-.757-.501-1.244-.167-1.515.274-2.842 1.34-3.921Z"
        fill="#000"
      />
      <defs>
        <linearGradient
          id={circleGradientId}
          x1="3.441"
          y1=".445"
          x2="34.171"
          y2="37.869"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset=".01" stopColor="#5433FF" />
          <stop offset=".52" stopColor="#20BDFF" />
          <stop offset="1" stopColor="#A5FECB" />
        </linearGradient>
      </defs>
    </svg>
  );
};
